import React, { Fragment, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../state/reducers/global";
import ModalInsert from "../../components/ModalInsert";
import Panel from "../../components/Panel";
import VendorInformationRequestMessage from "../../components/VendorInformationRequest/VendorInformationRequestMessage";
import VendorInformationRequestDecision from "../VendorInformationRequestDecision";
import {
  InformationRequestReasonContext,
  InformationRequestReasonValidationContext,
} from "../../components/VendorInformationRequest/VendorInformationRequestMessage/context/context";

const VendorInformationRequestModalInsert = () => {
  const dispatch = useDispatch();
  const activeClaimId = useSelector(
    (state) => state.global.claims.activeClaimId
  );

  const [informationRequestDecision, setInformationRequestDecision] = useState(
    false
  );

  const { informationRequestReason } = useContext(
    InformationRequestReasonContext
  );

  const { validInformationRequestReason } = useContext(
    InformationRequestReasonValidationContext
  );

  const claimData = {
    vendorNotes: informationRequestReason,
    claimId: activeClaimId,
  };

  const onCancel = () => {
    dispatch(closeModal());
  };

  const onClickRequestInformationDecision = () => {
    setInformationRequestDecision(true);
  };

  return (
    <Fragment>
      <ModalInsert>
        {informationRequestDecision ? (
          <VendorInformationRequestDecision claimData={claimData} />
        ) : (
          <Panel
            mobileFlex
            style={{ height: "100%", borderRadius: "0.5rem" }}
            actions={[
              {
                content: "Close",
                action: onCancel,
                type: "ghost",
              },
              {
                content: "Submit",
                action: onClickRequestInformationDecision,
                type: "primary",
                disabled: !validInformationRequestReason,
              },
            ]}
          >
            <VendorInformationRequestMessage />
          </Panel>
        )}
      </ModalInsert>
    </Fragment>
  );
};

export default VendorInformationRequestModalInsert;
